var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { TokenClient } from '../../../../services/authentication/token-client.service';
var Support = /** @class */ (function () {
    function Support(tokenClient) {
        this.tokenClient = tokenClient;
    }
    Support.prototype.loadFrame = function (uri) {
        setTimeout(function () {
            var frame = '<iframe id="iframe-host" style="width: 100%; height: 100%; border: 0; flex-grow: 1; background-color: #fff;" src="' + uri + '"></iframe>';
            $("#iframe-host").append(frame);
        }, 100);
    };
    Support.prototype.activate = function () {
        this.loadFrame(this.tokenClient.supportUri);
    };
    Support = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient])
    ], Support);
    return Support;
}());
export { Support };
